<template>
  <BaseButton primary @click="open"> Add Approval Claim </BaseButton>
</template>

<script>
import { projectAssetApprovalClaimsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('./ApprovalClaimCreateModal.vue'),
        props: {
          projectId: this.projectAsset.projectId,
          action: async (formData) => {
            this.loading = true;

            try {
              await projectAssetApprovalClaimsClient.store(
                this.projectAsset.id,
                mapKeysToSnakeCase(formData)
              );

              this.$emit('approval-claim-created');

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            } finally {
              this.loading = false;
            }
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
